export default {
    beforeDestroy () {
        this.$window.off(this.$window.EVENTS.CHANGE_BREAKPOINT, this.$_resizable_onChangeBreakpoint)
    },
    computed: {
        isWindowSmall () {
            return this.currentBreakpoint$ === this.$window.BREAKPOINTS.SMALL
        },
        isWindowMedium () {
            return this.currentBreakpoint$ === this.$window.BREAKPOINTS.MEDIUM
        },
        isWindowLarge () {
            return this.currentBreakpoint$ === this.$window.BREAKPOINTS.LARGE
        },
        isWindowXLarge () {
            return this.currentBreakpoint$ === this.$window.BREAKPOINTS.XLARGE
        }
    },
    data () {
        return {
            currentBreakpoint$: this.$window.getBreakpoint()
        }
    },
    methods: {
        $_resizable_onChangeBreakpoint (newBreakpoint) {
            this.currentBreakpoint$ = newBreakpoint
        }
    },
    mounted () {
        this.$window.on(this.$window.EVENTS.CHANGE_BREAKPOINT, this.$_resizable_onChangeBreakpoint)
    }
}
